import {Moment} from 'moment';
import React, {FC, useMemo} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {ActionButton} from 'components/table/action/action-button';
import {ITableActionProps} from 'components/table/action/table-action-types';
import {selectTableEntityData} from 'modules/data/data-selectors';
import {useAppSelector} from 'store/config/hooks';

import {useProjectInvestmentInfoServiceModal} from '../hooks';
import {ProjectInvestmentInfoServiceModalForm} from './project-investment-info-service-modal-form';

interface IProjectInvestmentInfoServiceModalOpenerProps extends ITableActionProps {
    serviceName?: string;
    reportingDate?: Moment;
    adjNumber?: number;
    hasInvestmentProject?: string;
}

export const ProjectInvestmentInfoServiceModalOpener: FC<IProjectInvestmentInfoServiceModalOpenerProps> = ({
    meta,
    wrapper,
    entityName,
    serviceName,
    ...props
}: IProjectInvestmentInfoServiceModalOpenerProps) => {
    const tableData = useAppSelector(selectTableEntityData(entityName || ''));
    const selectedRows = useMemo(() => tableData?.selectedRows || [], [tableData?.selectedRows]);

    const {
        modalRef,
        isOpen,
        form,
        setIsOpen,
        handleCloseModal,
        handleFinish,
    } = useProjectInvestmentInfoServiceModal({serviceName, selectedRows, entityName: entityName || ''});

    const ActionButtonComponent = wrapper || ActionButton;

    return (
        <ModalOpenerComponent
            ref={modalRef}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            handleSave={() => {
                form.submit();
            }}
            handleCancel={setIsModalOpen => {
                handleCloseModal(setIsModalOpen);
            }}
            hideControls={{all: true}}
            component={(
                <>
                    <ActionButtonComponent
                        {...props}
                        actionIcon={meta.actionIcon}
                    >
                        {meta.actionTitle}
                    </ActionButtonComponent>
                </>
            )}
            modalProps={{
                title: 'Вызвать сервис',
                forceRender: true,
                centered: true,
                className: 'project-investment-info-service-modal',
            }}
        >
            <ProjectInvestmentInfoServiceModalForm
                form={form}
                handleFinish={handleFinish}
            />
        </ModalOpenerComponent>
    );
};

